import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row p-2 pb-0" }
const _hoisted_2 = { class: "col-12 col-lg-12 px-5 g-0" }
const _hoisted_3 = {
  key: 0,
  class: "form-group col-12"
}
const _hoisted_4 = { class: "row form-check ps-0 mt-2" }
const _hoisted_5 = { class: "border p-1 d-flex align-items-center rounded service-required-wrapper" }
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "me-1 text-capitalize" }
const _hoisted_9 = { class: "col-lg-3 col-md-6 col-sm-12 p-1" }
const _hoisted_10 = { class: "border p-1 d-flex rounded flex-column service-required-wrapper" }
const _hoisted_11 = { class: "d-flex align-items-center service-required-inner-wrapper" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "other",
  class: "mb-0"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1 text-capitalize" }, "Other")
], -1 /* HOISTED */)
const _hoisted_14 = {
  key: 0,
  class: "d-flex mt-2 bg-white flex-column p-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "mb-1 mt-1 service-required-text-color" }, "Specify ", -1 /* HOISTED */)
const _hoisted_16 = {
  key: 1,
  class: "form-group col-12"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading me-2 block-size-2" }, null, -1 /* HOISTED */)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading me-2 block-size-2" }, null, -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-2" }, null, -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Services Required",
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicesRequired, (serviceRequired) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-lg-3 col-md-6 col-sm-12 p-1",
                      key: serviceRequired.Id
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "me-3 ms-2 service-required-input",
                          id: serviceRequired.Id,
                          value: serviceRequired.Value.toFixed(),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.serviceRequiredCollection) = $event)),
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateServiceRequiredCollection && _ctx.updateServiceRequiredCollection(...args)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_6), [
                          [_vModelCheckbox, _ctx.serviceRequiredCollection]
                        ]),
                        _createElementVNode("label", {
                          for: `${serviceRequired.Id}`,
                          class: "mb-0"
                        }, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(serviceRequired.Name), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_7)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "me-3 ms-2 service-required-input",
                          id: "other",
                          value: _ctx.referral.hasOtherServicesRequired,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.hasOtherServicesRequired) = $event)),
                          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearOtherServices && _ctx.clearOtherServices(...args)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_12), [
                          [_vModelCheckbox, _ctx.referral.hasOtherServicesRequired]
                        ]),
                        _hoisted_13
                      ]),
                      (_ctx.referral.hasOtherServicesRequired)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _hoisted_15,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ms-3 form-control w-90",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.hasOtherServiceRequired) = $event)),
                              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleOtherServiceRequired && _ctx.handleOtherServiceRequired(...args)))
                            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                              [_vModelText, _ctx.hasOtherServiceRequired]
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
                  return _createElementVNode("div", {
                    key: i,
                    class: "d-flex mt-4"
                  }, _hoisted_20)
                }), 64 /* STABLE_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}